import { Dispatch } from 'redux';
import { NAVIGATED_TO_VENUE_PROFILE, NAVIGATED_AWAY_FROM_VENUE_PROFILE } from '../constants';

export interface NavigatedVenueProfile {
    type: NAVIGATED_TO_VENUE_PROFILE;
    payload: { venueId: number };
}

export interface NavigatedAwayFromVenueProfile {
    type: NAVIGATED_AWAY_FROM_VENUE_PROFILE;
}

export type NavigationAction = NavigatedVenueProfile | NavigatedAwayFromVenueProfile;

export function navigatedToVenueProfile(venueId: number): (dispatch: Dispatch<NavigatedVenueProfile>) => void {
    return (dispatch: Dispatch<NavigatedVenueProfile>) => {
        return dispatch({
            type: NAVIGATED_TO_VENUE_PROFILE,
            payload: { venueId: venueId },
        });
    };
}

export function navigatedAwayFromVenueProfile(): (dispatch: Dispatch<NavigatedAwayFromVenueProfile>) => void {
    return (dispatch: Dispatch<NavigatedAwayFromVenueProfile>) => {
        return dispatch({ type: NAVIGATED_AWAY_FROM_VENUE_PROFILE });
    };
}
